import React, {useState} from "react";
// import CardMenu from "components/card/CardMenu";
import Card from "../Card";
import Progress from "../progress";
import { MdCancel, MdCheckCircle, MdOutlineError } from "react-icons/md";
import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  getSortedRowModel,
  SortingState,
  useReactTable,
} from "@tanstack/react-table";
import { IoMdArrowBack } from "react-icons/io";
import { formatTime, timeDiffer } from "../../utils/helper";


const columnHelper = createColumnHelper();

// const columns = columnsDataCheck;
export default function Table({ tableData,columns, onUserClick, handleBackBtn, title }) {
  
  const [sorting, setSorting] = useState([]);
    let defaultData = tableData;
  
  const [data, setData] = React.useState(() => [...defaultData]);
  const table = useReactTable({
    data,
    columns,
    state: {
      sorting,
          },
    onSortingChange: setSorting,
        getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
        debugTable: true,
      });
  return (
    <Card extra={"w-full h-full px-6 pb-6 sm:overflow-x-auto"}>
      { handleBackBtn && <IoMdArrowBack className=" mt-3" onClick={() => handleBackBtn(null)}/>}
      <div className="relative flex items-center justify-between pt-4">
        <div className="text-xl font-bold text-navy-700 dark:text-white">
          {title}
        </div>
      </div>

      <div className="mt-8 overflow-x-scroll xl:overflow-x-scroll">
        <table className="w-full">
          <thead>
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id} className="!border-px !border-gray-400">
                {headerGroup.headers.map((header) => {
                  return (
                    <th
                      key={header.id}
                      colSpan={header.colSpan}
                      onClick={header.column.getToggleSortingHandler()}
                      className="cursor-all-scroll border-b-[1px] border-gray-200 pt-4 pb-2 pr-4 text-start"
                    >
                      <div className="items-center justify-between text-xs text-gray-200">
                        {flexRender(
                          header.column.columnDef.header,
                          header.getContext()
                        )}
                        {{
                          asc: "",
                          desc: "",
                        }[header.column.getIsSorted()] ?? null}
                      </div>
                    </th>
                  );
                })}
              </tr>
            ))}
          </thead>
          <tbody>
            {table
              .getRowModel()
              .rows
              .map((row) => {
                return (
                  <tr key={row.id} onClick={() => onUserClick && onUserClick(row)}>
                    {row.getVisibleCells().map((cell) => {
                      return (
                        <td
                          key={cell.id}
                          className="min-w-[150px] border-white/0 py-3  pr-4"
                        >
                          {flexRender(
                            cell.column.columnDef.cell,
                            cell.getContext()
                          )}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
          </tbody>
        </table>
              </div>
    </Card>
  );
}
